export const TYPE_CHAT_VIBER = 1
export const TYPE_CHAT_VK = 2
export const TYPE_CHAT_TELEGRAM = 3
export const TYPE_CHAT_MAX = 4

export const TYPE_CHAT_LABELS = {
  [TYPE_CHAT_VIBER]: 'Viber',
  [TYPE_CHAT_VK]: 'VK',
  [TYPE_CHAT_TELEGRAM]: 'Telegram',
  [TYPE_CHAT_MAX]: 'MAX',
}



// WEBPACK FOOTER //
// src/shared/utils/constant.js